export default __webpack_public_path__ + "static/media/i122jp.ffbbb3e5.webp";